@if (rendering && viewModel$ | async; as vm) {
  @if (vm.isVisible && (products$ | async); as products) {
    <div [id]="solarPanelsProductOverviewKey">
      <wl-generic-offer-container
        [products]="products"
        [listName]="productListName"
      >
        <ng-template let-implicitProduct let-context="context">
          @if (stronglyTypedProduct(implicitProduct); as product) {
            <div class="h-100">
              <wl-generic-offer
                [rendering]="rendering"
                [wlTrackProduct]="{
                  track: product,
                  trackingConfig: trackProductConfig,
                  context: context,
                  trackMode: 'product-impression',
                }"
                [product]="product"
                (clicked)="onProductClicked(product, context)"
                [buttonTextField]="chooseProductButtonTextField"
                class="d-flex h-100"
              >
                <wl-solar-panels-product-info
                  top
                  [rendering]="rendering"
                  [product]="product"
                ></wl-solar-panels-product-info>
              </wl-generic-offer>
            </div>
          }
        </ng-template>
      </wl-generic-offer-container>
    </div>
  }
}
